<template>
  <section class="app-news border container">
    <h3 class="block__topic" id="news">大赛动态</h3>

    <div class="app-news-container">
      <div class="app-news-container-l">
        <div
          v-if="recommendList.length"
          style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
        >
          <vue-slick-carousel v-if="recommendList.length" key="left" ref="carousel" v-bind="slickSettings" @afterChange="onAfterChange">
            <a v-for="item in recommendList" :key="item.id" class="slide-item" :href="item.web_redirect_url || item.detail_url" target="_blank" :style="{ background: `url(${item.web_thumbs ? item.web_thumbs[0] : ''}) center/cover no-repeat` }">
              <!-- <img :src="item.web_thumbs ? item.web_thumbs[0] : ''" width="100%"> -->
            </a>
          </vue-slick-carousel>
        </div>

        <div class="app-news-container-l-title">
          {{ current ? current.title : '' }}
          <ul>
            <li 
              v-for="item in recommendList"
              :key="item.id"
              :class="{ active: item.id === current.id }"
              @click="() => onGoto(i)"
            ></li>
          </ul>
        </div>
      </div>
      <div class="app-news-container-r">
        <template v-if="isMobile && newsList.length">
          <div style="width: 90%; margin: 0 auto">
            <vue-slick-carousel key="mobileSlider" ref="carousel2" v-bind="mobileSlickSettings">
              <a v-for="item in newsList" :key="item.id" :href="item.web_redirect_url || item.detail_url" target="_blank" class="app-news-container-r-item">
                <div class="app-news-container-r-item__cover" :style="{ background: `url(${item.web_thumbs ? item.web_thumbs[0] : ''}) center/cover no-repeat` }"></div>
                <div class="app-news-container-r-item__title">
                  {{ item.title }}
                </div>
              </a>
            </vue-slick-carousel> 
          </div>

          <span class="arrow-prev" @click="onSlickPrev"></span>
          <span class="arrow-next" @click="onSlickNext"></span>
        </template>

        <a v-else v-for="item in newsList" :key="item.id" :href="item.web_redirect_url || item.detail_url" target="_blank" class="app-news-container-r-item">
          <div class="app-news-container-r-item__cover" :style="{ background: `url(${item.web_thumbs ? item.web_thumbs[0] : ''}) center/cover no-repeat` }"></div>
          <div class="app-news-container-r-item__title">
            <v-clamp autoresize :max-lines="2">{{ item.title }}</v-clamp>
          </div>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import device from '@jin10/utils/lib/device'
import VClamp from 'vue-clamp'
import VueSlickCarousel from "vue-slick-carousel"
import "vue-slick-carousel/dist/vue-slick-carousel.css"
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css"
import { getReference } from '@/api'

export default {
  name: "News",
  components: {
    VClamp,
    VueSlickCarousel,
  },
  data() {
    return {
      slickSettings: {
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        touchThreshold: 5,
        lazyLoad: 'ondemand'
      },
      mobileSlickSettings: {
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        touchThreshold: 5,
        arrows: false,
        lazyLoad: 'ondemand'
      },
      current: {},
      isMobile: false,
      recommendList: [],
      newsList: []
    }
  },
  mounted() {
    getReference({ category_id: 344, types: 'news', page_size: 50 }).then(res => {
      const { list = [] } = res.data
      const recommendListLength = list.length / 4

      this.recommendList = list.splice(0, recommendListLength)
      this.current = this.recommendList[0]
      this.newsList = list
    }).catch(err => {
      console.log(err)
    })

    this.isMobile = device.isMobile || document.documentElement.clientWidth <= 768
  },
  methods: {
    onSlickPrev() {
      this.$refs.carousel2.prev()
    },
    onSlickNext() {
      this.$refs.carousel2.next()
    },
    onAfterChange(index) {
      this.current = this.recommendList[index]
    },
    onGoto(index) {
      this.$refs.carousel.goTo(index)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/vars.scss";
@import "../../styles/mixin.scss";

.app-news {
  position: relative;
  margin: percentage(124px / $baseWidth) auto 0;
  border: 2px solid;
  border-image: linear-gradient(
      360deg,
      rgba(134, 76, 46, 0.26),
      rgba(134, 76, 46, 0.52),
      rgba(134, 76, 46, 0.46),
      rgba(134, 76, 46, 1),
      rgba(134, 76, 46, 0.2)
    )
    2 2;
  border-top: none;
  border-top: 0;
  padding: percentage(54px / 1200px) percentage(16px / 1200px)
    percentage(36px / 1200px);
  box-sizing: border-box;

  &-container {
    overflow: hidden;
    position: relative;

    &-l {
      position: relative;
      width: percentage(730px / 1148px);
      float: left;
      flex: none;
      padding-top: percentage(411px / 1148px);
      &-title {
        position: absolute;
        bottom: 0;
        width: 100%;
        padding: 12px 90px 11px 10px;
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        color: #ebc4bc;
        background: rgba(0, 0, 0, 1);
        opacity: 0.7;

        ul,
        li {
          margin: 0;
          padding: 0;
          list-style: none;
        }

        ul {
          position: absolute;
          right: 25px;
          top: 50%;
          transform: translate(0, -50%);
          line-height: 0;
        }

        li {
          display: inline-block;
          margin: 0 2px;
          width: 6px;
          height: 6px;
          background: #392623;
          border-radius: 100%;
          overflow: hidden;
          cursor: pointer;

          &.active {
            background: #9C6159;
          }
        }
      }

      .slide-item {
        width: 100%;
      }
    }

    &-r {
      position: absolute;
      height: 100%;
      right: 0;
      top: 0;
      width: percentage((1148px - 730px) / 1148px);
      overflow: auto;

      &-item {
        display: inline-block;
        width: percentage(180px / 418px);
        margin-bottom: percentage(27px / 418px);
        margin-left: percentage(24px / 418px);

        &__cover {
          padding-top: percentage(100px / 180px);
        }

        &__title {
          margin-top: percentage(10px / 180px);
          font-size: 14px;
          line-height: 18px;
          color: #9c6159;
          @include line(2);
        }
      }
    }
  }

  .block__topic {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -65.0625%);
    @include image-2x(
      "../../assets/title-news@1x.png",
      center top,
      no-repeat,
      100% auto
    );

    &:before,
    &:after {
      content: "";
      position: absolute;
      top: percentage(21px / 83px);
      width: percentage(139px / 137px);
      padding-top: percentage(6px / 137px);
    }

    &:before {
      left: -100%;
      margin-left: -18px;
      background: url(../../assets/title-line.png) center/contain no-repeat;
    }

    &:after {
      right: -100%;
      margin-right: -18px;
      background: url(../../assets/title-line.png) center/contain no-repeat;
      transform: rotate(180deg);
    }
  }
}

@include mobile {
  .app-news {

    &-container {
      &-l {
        width: 100%;
        padding-top: percentage(219px / 406px);

        &-title {
          font-size: 12px;
          padding: 5px 80px 5px 8px;;
          @include line(1);

          ul {
            right: 14px;
          }
        }
      }

      .arrow-next, .arrow-prev {
        position: absolute;
        top: 50%;
        width: 18px;
        height: 18px;
      }

      .arrow-next {
        position: absolute;
        right: 0;
        @include arrow-right(21px);
      }

      .arrow-prev {
        @include arrow-left(21px);
      }

      &-r {
        width: 100%;
        position: relative;
        margin: 0 auto;
        padding: percentage(24px / 406px) 0 0;

        &-item {
          margin-left: 0;
          margin-right: 0;
          
          &__title {
            font-size: 12px;
            line-height: 16px;
          }
        }

        /deep/.slick-slide {
          padding: 0 6px;
        }

        /deep/.slick-arrow {
          transform: translate(0, -100%);
        }

        /deep/.slick-prev {
          left: 0
        }

        /deep/.slick-next {
          right: 0
        }
      }
    }
  }
}
</style>
